import { inject, Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { isSameSort, parseSortParam, serializeSortParam } from '../utils/sort-param.util';

const SORT_QUERY_PARAM = 'sort';

@Injectable({ providedIn: 'root' })
export class SortUrlService {
	private activatedRoute = inject(ActivatedRoute);
	private router = inject(Router);

	read(defaultSort: Sort, sortableColumns?: string[], paramName = SORT_QUERY_PARAM): Sort {
		const sort = parseSortParam(this.activatedRoute.snapshot.queryParams[paramName]);

		if (!sort || (sortableColumns && !sortableColumns.includes(sort.active))) {
			return defaultSort;
		}

		return sort;
	}

	write(sort: Sort, defaultSort: Sort, paramName = SORT_QUERY_PARAM): void {
		const value = isSameSort(sort, defaultSort) ? null : serializeSortParam(sort);

		if ((this.activatedRoute.snapshot.queryParams[paramName] ?? null) === value) {
			return;
		}

		this.router.navigate([], {
			queryParams: { [paramName]: value },
			queryParamsHandling: 'merge',
			replaceUrl: true,
		});
	}
}
